import { GrapevineSuggestionApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';

import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';

export const useGrapevineSuggestionApi = () => {
  const configuration = useApiConfiguration();
  return useMemo(
    () => new GrapevineSuggestionApi(configuration),
    [configuration]
  );
};
